import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/shared/services/auth/auth.service';
import { UserLoginResponseDto } from 'src/app/shared/models/auth/auth-dto';
import { Router } from '@angular/router';

@Component({
    selector: 'app-welcome',
    templateUrl: './welcome.component.html',
    styleUrl: './welcome.component.scss',
    standalone: false
})
export class WelcomeComponent implements OnInit {
  userData: UserLoginResponseDto = null;
  currentDate = new Date();
  formattedDate = this.formatDateTitleCase(this.currentDate);

  constructor(private readonly authService: AuthService, private readonly router: Router) {}

  get isMichelinUser(): boolean {
    return this.userData.userProfile?.userType === 'MICHELIN';
  }

  get isDistributorUser(): boolean {
    return this.userData.userProfile?.userType === 'DISTRIBUTOR';
  }

  hasPermissions(permissions: string[]): boolean {
    return this.authService.hasPermissions(permissions);
  }

  ngOnInit(): void {
    this.userData = this.authService.getUserData();
  }

  private formatDateTitleCase(date: Date): string {
    const raw = date.toLocaleDateString('pt-BR', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
    return raw.replace(/\b\w/g, (char) => char.toUpperCase());
  }
}
